import { render } from "./SignupForm.vue?vue&type=template&id=34979199&scoped=true&ts=true"
import script from "./SignupForm.vue?vue&type=script&lang=ts"
export * from "./SignupForm.vue?vue&type=script&lang=ts"

import "./SignupForm.vue?vue&type=style&index=0&id=34979199&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34979199"]])

export default __exports__